unit SystemLedgerAccountSetup;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, WEBLib.ExtCtrls, Vcl.StdCtrls,
  WEBLib.StdCtrls, WEBLib.DBCtrls;

type
  TfrmSystemLedgerAccountSetup = class(TForm)
    WebPanel1: TPanel;
    WebPanel2: TPanel;
    WebPanel3: TPanel;
    WebButton1: TButton;
    WebButton2: TButton;
    WebLabel1: TLabel;
    WebLabel2: TLabel;
    WebLabel3: TLabel;
    WebLabel4: TLabel;
    WebDBLookupComboBox1: TDBLookupComboBox;
    WebDBLookupComboBox2: TDBLookupComboBox;
    WebDBLookupComboBox3: TDBLookupComboBox;
    WebDBLookupComboBox4: TDBLookupComboBox;
  private
    { Private declarations }
  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;

var
  frmSystemLedgerAccountSetup: TfrmSystemLedgerAccountSetup;

implementation

{$R *.dfm}

procedure TfrmSystemLedgerAccountSetup.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebPanel1 := TPanel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  WebLabel3 := TLabel.Create(Self);
  WebLabel4 := TLabel.Create(Self);
  WebPanel2 := TPanel.Create(Self);
  WebPanel3 := TPanel.Create(Self);
  WebButton1 := TButton.Create(Self);
  WebButton2 := TButton.Create(Self);
  WebDBLookupComboBox1 := TDBLookupComboBox.Create(Self);
  WebDBLookupComboBox2 := TDBLookupComboBox.Create(Self);
  WebDBLookupComboBox3 := TDBLookupComboBox.Create(Self);
  WebDBLookupComboBox4 := TDBLookupComboBox.Create(Self);

  WebPanel1.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  WebLabel4.BeforeLoadDFMValues;
  WebPanel2.BeforeLoadDFMValues;
  WebPanel3.BeforeLoadDFMValues;
  WebButton1.BeforeLoadDFMValues;
  WebButton2.BeforeLoadDFMValues;
  WebDBLookupComboBox1.BeforeLoadDFMValues;
  WebDBLookupComboBox2.BeforeLoadDFMValues;
  WebDBLookupComboBox3.BeforeLoadDFMValues;
  WebDBLookupComboBox4.BeforeLoadDFMValues;
  try
    Name := 'frmSystemLedgerAccountSetup';
    Width := 640;
    Height := 417;
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 640;
    WebPanel1.Height := 417;
    WebPanel1.Align := alClient;
    WebPanel1.TabOrder := 0;
    WebLabel1.SetParentComponent(WebPanel1);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 240;
    WebLabel1.Top := 80;
    WebLabel1.Width := 69;
    WebLabel1.Height := 15;
    WebLabel1.Caption := 'System Type:';
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.WidthPercent := 100.000000000000000000;
    WebLabel2.SetParentComponent(WebPanel1);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 240;
    WebLabel2.Top := 144;
    WebLabel2.Width := 56;
    WebLabel2.Height := 15;
    WebLabel2.Caption := 'Fleet Type:';
    WebLabel2.HeightPercent := 100.000000000000000000;
    WebLabel2.WidthPercent := 100.000000000000000000;
    WebLabel3.SetParentComponent(WebPanel1);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 240;
    WebLabel3.Top := 208;
    WebLabel3.Width := 59;
    WebLabel3.Height := 15;
    WebLabel3.Caption := 'Value Type:';
    WebLabel3.HeightPercent := 100.000000000000000000;
    WebLabel3.WidthPercent := 100.000000000000000000;
    WebLabel4.SetParentComponent(WebPanel1);
    WebLabel4.Name := 'WebLabel4';
    WebLabel4.Left := 240;
    WebLabel4.Top := 280;
    WebLabel4.Width := 65;
    WebLabel4.Height := 15;
    WebLabel4.Caption := 'GL Account:';
    WebLabel4.HeightPercent := 100.000000000000000000;
    WebLabel4.WidthPercent := 100.000000000000000000;
    WebPanel2.SetParentComponent(WebPanel1);
    WebPanel2.Name := 'WebPanel2';
    WebPanel2.Left := 0;
    WebPanel2.Top := 0;
    WebPanel2.Width := 640;
    WebPanel2.Height := 40;
    WebPanel2.Align := alTop;
    WebPanel2.Caption := 'System Ledger Accounts';
    WebPanel2.Font.Charset := DEFAULT_CHARSET;
    WebPanel2.Font.Color := clWindowText;
    WebPanel2.Font.Height := -16;
    WebPanel2.Font.Name := 'Segoe UI';
    WebPanel2.Font.Style := [fsBold];
    WebPanel2.ParentFont := False;
    WebPanel2.TabOrder := 0;
    WebPanel3.SetParentComponent(WebPanel1);
    WebPanel3.Name := 'WebPanel3';
    WebPanel3.Left := 0;
    WebPanel3.Top := 372;
    WebPanel3.Width := 640;
    WebPanel3.Height := 45;
    WebPanel3.Align := alBottom;
    WebPanel3.ChildOrder := 1;
    WebPanel3.TabOrder := 1;
    WebButton1.SetParentComponent(WebPanel3);
    WebButton1.Name := 'WebButton1';
    WebButton1.Left := 13;
    WebButton1.Top := 10;
    WebButton1.Width := 96;
    WebButton1.Height := 25;
    WebButton1.Caption := 'Save';
    WebButton1.HeightPercent := 100.000000000000000000;
    WebButton1.WidthPercent := 100.000000000000000000;
    WebButton2.SetParentComponent(WebPanel3);
    WebButton2.Name := 'WebButton2';
    WebButton2.Left := 129;
    WebButton2.Top := 10;
    WebButton2.Width := 96;
    WebButton2.Height := 25;
    WebButton2.Caption := 'Cancel';
    WebButton2.ChildOrder := 1;
    WebButton2.HeightPercent := 100.000000000000000000;
    WebButton2.WidthPercent := 100.000000000000000000;
    WebDBLookupComboBox1.SetParentComponent(WebPanel1);
    WebDBLookupComboBox1.Name := 'WebDBLookupComboBox1';
    WebDBLookupComboBox1.Left := 240;
    WebDBLookupComboBox1.Top := 101;
    WebDBLookupComboBox1.Width := 145;
    WebDBLookupComboBox1.Height := 22;
    WebDBLookupComboBox1.HeightPercent := 100.000000000000000000;
    WebDBLookupComboBox1.WidthPercent := 100.000000000000000000;
    WebDBLookupComboBox2.SetParentComponent(WebPanel1);
    WebDBLookupComboBox2.Name := 'WebDBLookupComboBox2';
    WebDBLookupComboBox2.Left := 240;
    WebDBLookupComboBox2.Top := 165;
    WebDBLookupComboBox2.Width := 145;
    WebDBLookupComboBox2.Height := 22;
    WebDBLookupComboBox2.HeightPercent := 100.000000000000000000;
    WebDBLookupComboBox2.WidthPercent := 100.000000000000000000;
    WebDBLookupComboBox3.SetParentComponent(WebPanel1);
    WebDBLookupComboBox3.Name := 'WebDBLookupComboBox3';
    WebDBLookupComboBox3.Left := 240;
    WebDBLookupComboBox3.Top := 240;
    WebDBLookupComboBox3.Width := 145;
    WebDBLookupComboBox3.Height := 22;
    WebDBLookupComboBox3.HeightPercent := 100.000000000000000000;
    WebDBLookupComboBox3.WidthPercent := 100.000000000000000000;
    WebDBLookupComboBox4.SetParentComponent(WebPanel1);
    WebDBLookupComboBox4.Name := 'WebDBLookupComboBox4';
    WebDBLookupComboBox4.Left := 240;
    WebDBLookupComboBox4.Top := 312;
    WebDBLookupComboBox4.Width := 145;
    WebDBLookupComboBox4.Height := 22;
    WebDBLookupComboBox4.HeightPercent := 100.000000000000000000;
    WebDBLookupComboBox4.WidthPercent := 100.000000000000000000;
  finally
    WebPanel1.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    WebLabel4.AfterLoadDFMValues;
    WebPanel2.AfterLoadDFMValues;
    WebPanel3.AfterLoadDFMValues;
    WebButton1.AfterLoadDFMValues;
    WebButton2.AfterLoadDFMValues;
    WebDBLookupComboBox1.AfterLoadDFMValues;
    WebDBLookupComboBox2.AfterLoadDFMValues;
    WebDBLookupComboBox3.AfterLoadDFMValues;
    WebDBLookupComboBox4.AfterLoadDFMValues;
  end;
end;

end.